import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";

export const SocietyBlock = () => (
  <section id="society" data-testid="society-block" className="relative py-28 md:py-44 border-t border-bds-border">
    <div className="mx-auto max-w-[1100px] px-6 md:px-12">
      <Reveal>
        <span className="font-mono-bds text-xs uppercase tracking-[0.3em] text-bds-accent">The Society</span>
      </Reveal>
      <Reveal delay={0.05}>
        <h2 className="font-serif-display font-light text-4xl md:text-6xl lg:text-7xl tracking-tighter leading-[0.95] mt-6 mb-10">
          Membership begins<br />with <span className="italic text-bds-muted">acquisition.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="font-grotesk text-base md:text-lg text-bds-muted leading-relaxed max-w-xl mb-10">
          Every Chapter I collector receives an individually numbered Black Dog
          Society membership credential. It is recorded in the Archive, and it is
          where your relationship with the Society begins.
        </p>
      </Reveal>
      <Reveal delay={0.15}>
        <Link
          to="/society"
          data-testid="society-page-link"
          className="font-mono-bds text-xs uppercase tracking-[0.25em] text-bds-muted hover:text-bds-fg border-b border-bds-border hover:border-bds-fg pb-1 transition-colors"
        >
          About the Society →
        </Link>
      </Reveal>
    </div>
  </section>
);
